
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Ticket extends Vue {
    @Prop() author?: string;
}
